import ApplicationController from './application_controller.js'
import { leave, toggle } from 'el-transition'
export default class extends ApplicationController {
  static targets = ['column', 'order', 'input']
  connect() {
    super.connect()
  }

  toggle() {
    console.log('Toggled')
    toggle(this.orderTarget)
  }

  hide(event) {
    const buttonClicked = this.columnTarget.contains(event.target)
    const orderClicked = this.orderTarget.contains(event.target)
    const inputClicked = this.inputTarget.contains(event.target)
    if (inputClicked) {
      console.log(
        'Button clicked: ',
        buttonClicked,
        'Order clicked: ',
        orderClicked,
        'Clicked: ',
        event.target
      )
    }
    if (!buttonClicked) {
      console.log(
        'Button clicked: ',
        buttonClicked,
        'Order clicked: ',
        orderClicked,
        'Clicked: ',
        event.target
      )
      leave(this.orderTarget)
    }
  }
}
